// 附近的人
export default {
  routes: [
    // 首页
    {
      path: '/zzNearbyPerson/index',
      name: 'zzNearbyPersonIndex',
      meta: {
        desc: '附近的人首页'
      },
      component: () =>
        import(
          /* webpackChunkName: "zzNearbyPersonIndex" */ '../views/zzNearbyPerson/index/index.vue'
        )
    },
    // 搜索中间页
    {
      path: '/zzNearbyPerson/search',
      name: 'zzNearbyPersonSearch',
      meta: {
        desc: '附近的人搜索中间页'
      },
      component: () =>
        import(
          /* webpackChunkName: "zzNearbyPersonSearch" */ '../views/zzNearbyPerson/search/index.vue'
        )
    },
    // 搜索结果页
    {
      path: '/zzNearbyPerson/searchResult',
      name: 'zzNearbyPersonSearchResult',
      meta: {
        desc: '附近的人搜索结果页'
      },
      component: () =>
        import(
          /* webpackChunkName: "zzNearbyPersonSearchResult" */ '../views/zzNearbyPerson/searchResult/index.vue'
        )
    },
    {
      path: '/zzNearbyPerson/shuffle',
      name: 'zzNearbyPersonShuffle',
      meta: {
        desc: '单张翻牌demo'
      },
      component: () =>
        import(
          /* webpackChunkName: "zzNearbyPersonFlipPoker" */ '../views/zzNearbyPerson/index/shuffle.vue'
        )
    },
    {
      path: '/zzNearbyPerson/flipPoker',
      name: 'zzNearbyPersonFlipPoker',
      meta: {
        desc: '单张翻牌demo'
      },
      component: () =>
        import(
          /* webpackChunkName: "zzNearbyPersonFlipPoker" */ '../views/zzNearbyPerson/index/flipPoker.vue'
        )
    },
    {
      path: '/zzNearbyPerson/test',
      name: 'zzNearbyPersonTest',
      meta: {
        desc: '附近的人搜索结果页'
      },
      component: () =>
        import(
          /* webpackChunkName: "zzNearbyPersonSearchResult" */ '../views/zzNearbyPerson/index/test.vue'
        )
    }
  ]
}
